/* eslint-disable max-len */

interface IconProps {
    fill?: string;
    width?: string;
    height?: string;
    className?: string;
    style?: React.CSSProperties;
}

export const CustomIcons = {
    /** Source: https://iconmonstr.com/sitemap-2-svg/ */
    siteMap: (): JSX.Element => (
        <svg width="18" height="18" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M14 2v2h-4v-2h4zm2-2h-8v6h8v-6zm-10 20v2h-4v-2h4zm2-2h-8v6h8v-6zm14 2v2h-4v-2h4zm2-2h-8v6h8v-6zm-11-7v-3h-2v3h-8v5h2v-3h14v3h2v-5h-8z"
            />
        </svg>
    ),
    playMenu: (): JSX.Element => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="currentColor"
                d="M3 16V14H11V16H3ZM3 12V10H15V12H3ZM3 8V6H15V8H3ZM16 21V13L22 17L16 21Z"
            />
        </svg>
    ),
    delete: (): JSX.Element => (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.80692 14.415C4.46029 14.415 4.16437 14.2924 3.91915 14.0472C3.67392 13.802 3.55131 13.5061 3.55131 13.1594V3.55048H2.56815V2.55264H6.03365V1.68112H9.98317V2.55131H13.4487V3.55048H12.4655V13.1522C12.4655 13.5103 12.3435 13.8103 12.0996 14.0522C11.8556 14.2941 11.559 14.415 11.2099 14.415H4.80692ZM11.4664 3.55048H4.55048V13.1594C4.55048 13.2342 4.57452 13.2957 4.6226 13.3437C4.67069 13.3918 4.73213 13.4159 4.80692 13.4159H11.2099C11.274 13.4159 11.3328 13.3892 11.3862 13.3357C11.4396 13.2823 11.4664 13.2235 11.4664 13.1594V3.55048ZM6.42069 11.9391H7.41988V5.02323H6.42069V11.9391ZM8.59696 11.9391H9.59613V5.02323H8.59696V11.9391Z"
                fill="#242423"
            />
        </svg>
    ),
    refresh: (): JSX.Element => (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.49997 15.5403C7.60894 15.5403 6.77375 15.3714 5.99441 15.0338C5.21505 14.6961 4.53465 14.2366 3.95322 13.6551C3.37179 13.0737 2.91225 12.3933 2.57459 11.614C2.23694 10.8346 2.06812 9.99941 2.06812 9.10838H3.06728C3.06728 10.5998 3.59987 11.8782 4.66503 12.9433C5.7302 14.0085 7.00851 14.5411 8.49997 14.5411C9.99143 14.5411 11.2697 14.0102 12.3349 12.9485C13.4001 11.8868 13.9327 10.6089 13.9327 9.1148C13.9327 7.62334 13.4001 6.34676 12.3349 5.28507C11.2697 4.22337 9.98872 3.69253 8.49184 3.69253H8.26199L9.35653 4.78707L8.63299 5.46092L6.3566 3.17651L8.64903 0.89209L9.37255 1.58278L8.24116 2.69336H8.49997C9.391 2.69336 10.2262 2.86219 11.0055 3.19984C11.7849 3.53749 12.4653 3.99596 13.0467 4.57526C13.6282 5.15455 14.0877 5.83387 14.4253 6.61324C14.763 7.3926 14.9318 8.22645 14.9318 9.1148C14.9318 10.0015 14.763 10.8357 14.4253 11.6172C14.0877 12.3987 13.6282 13.079 13.0467 13.6583C12.4653 14.2376 11.7849 14.6961 11.0055 15.0338C10.2262 15.3714 9.391 15.5403 8.49997 15.5403Z"
                fill="#242423"
            />
        </svg>
    ),
    combined: (): JSX.Element => (
        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.27502 15.7183L0.428772 14.8673L4.37877 10.9345C4.73461 10.582 4.99427 10.2153 5.15777 9.83425C5.32127 9.45308 5.40302 9.00317 5.40302 8.4845V2.57875L3.69802 4.301L2.84727 3.45475L6.00002 0.302002L9.15277 3.45475L8.30677 4.301L6.60202 2.57875V8.4845C6.60202 9.00317 6.68611 9.45625 6.85427 9.84375C7.0226 10.2313 7.28461 10.6013 7.64027 10.9538L11.576 14.8673L10.725 15.7183L6.00002 10.9933L1.27502 15.7183Z"
                fill="#242423"
            />
        </svg>
    ),
    arrowRight: ({ fill, width, height }: IconProps = {}): JSX.Element => (
        <svg
            width={width || '16'}
            height={height || '16'}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.2901 13.125L9.59136 12.4199L13.5177 8.48956H0.584961V7.4904H13.5257L9.58094 3.56411L10.2901 2.85498L15.423 7.99198L10.2901 13.125Z"
                fill={fill || '#242423'}
            />
        </svg>
    ),
    infoOutlined: ({ fill, width, height }: IconProps = {}): JSX.Element => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width || '16'}
            height={height || '16'}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M7.50884 11.7075H8.508V7.01684H7.50884V11.7075ZM7.99342 5.80771C8.15218 5.80771 8.28565 5.75582 8.39382 5.65202C8.502 5.54825 8.55609 5.41697 8.55609 5.25821C8.55609 5.09945 8.50419 4.96598 8.4004 4.85781C8.29662 4.74963 8.16535 4.69554 8.00659 4.69554C7.84782 4.69554 7.71436 4.74744 7.60619 4.85123C7.49801 4.95501 7.44392 5.08628 7.44392 5.24504C7.44392 5.40381 7.49582 5.53728 7.59961 5.64546C7.70338 5.75363 7.83466 5.80771 7.99342 5.80771ZM8.00765 15.415C6.98783 15.415 6.02713 15.2218 5.12554 14.8354C4.22396 14.4489 3.43471 13.917 2.75779 13.2396C2.08088 12.5623 1.54951 11.774 1.16369 10.8748C0.777871 9.97555 0.584961 9.01475 0.584961 7.99236C0.584961 6.96884 0.77819 6.00977 1.16465 5.11513C1.55109 4.22049 2.083 3.43471 2.76038 2.75779C3.43774 2.08088 4.22602 1.54951 5.12523 1.16369C6.02445 0.777871 6.98526 0.584961 8.00765 0.584961C9.03116 0.584961 9.99024 0.77819 10.8849 1.16465C11.7795 1.55109 12.5653 2.083 13.2422 2.76038C13.9191 3.43774 14.4505 4.22441 14.8363 5.12038C15.2221 6.01634 15.415 6.97366 15.415 7.99236C15.415 9.01218 15.2218 9.97288 14.8354 10.8745C14.4489 11.776 13.917 12.5653 13.2396 13.2422C12.5623 13.9191 11.7756 14.4505 10.8796 14.8363C9.98367 15.2221 9.02634 15.415 8.00765 15.415ZM7.99973 14.4159C9.77609 14.4159 11.2895 13.7907 12.5401 12.5403C13.7906 11.29 14.4159 9.77662 14.4159 8.00027C14.4159 6.22391 13.7907 4.71047 12.5403 3.45994C11.29 2.2094 9.77662 1.58413 8.00027 1.58413C6.22391 1.58413 4.71047 2.20931 3.45994 3.45967C2.2094 4.71003 1.58413 6.22338 1.58413 7.99973C1.58413 9.77609 2.20931 11.2895 3.45967 12.5401C4.71003 13.7906 6.22338 14.4159 7.99973 14.4159Z"
                fill={fill || '#242423'}
            />
        </svg>
    ),
    check: ({ fill, width, height, className, style }: IconProps = {}): JSX.Element => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width || '10'}
            height={height || '8'}
            viewBox="0 0 10 8"
            style={style}
            fill="none"
            className={className || ''}
        >
            <path
                d="M3.246 7.65783L0.147461 4.53845L0.835732 3.85016L3.246 6.2436L9.16827 0.342163L9.85254 1.05127L3.246 7.65783Z"
                fill={fill || '#242423'}
            />
        </svg>
    ),
    infoSuccess: ({ fill, width, height, className }: IconProps = {}): JSX.Element => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width || '16'}
            height={height || '16'}
            viewBox="0 0 16 16"
            fill="none"
            className={className}
        >
            <g clipPath="url(#clip0_4066_390)">
                <path
                    d="M6.93829 10.6274L11.5064 6.08013L10.7829 5.35659L6.93829 9.18032L5.20113 7.46396L4.47759 8.1875L6.93829 10.6274ZM8.00192 15.415C6.98592 15.415 6.02713 15.2218 5.12554 14.8354C4.22396 14.4489 3.43471 13.917 2.75779 13.2396C2.08088 12.5623 1.54951 11.7737 1.16369 10.8739C0.777871 9.97411 0.584961 9.01678 0.584961 8.00192C0.584961 6.97203 0.77819 6.00977 1.16465 5.11513C1.55109 4.22049 2.083 3.43471 2.76038 2.75779C3.43774 2.08088 4.22632 1.54951 5.12611 1.16369C6.0259 0.777871 6.98322 0.584961 7.99809 0.584961C9.02798 0.584961 9.99024 0.77819 10.8849 1.16465C11.7795 1.55109 12.5653 2.083 13.2422 2.76038C13.9191 3.43774 14.4505 4.22284 14.8363 5.11569C15.2221 6.00854 15.415 6.96934 15.415 7.99809C15.415 9.01409 15.2218 9.97288 14.8354 10.8745C14.4489 11.776 13.917 12.5653 13.2396 13.2422C12.5623 13.9191 11.7772 14.4505 10.8843 14.8363C9.99147 15.2221 9.03067 15.415 8.00192 15.415ZM7.99973 14.4159C9.77609 14.4159 11.2895 13.7907 12.5401 12.5403C13.7906 11.29 14.4159 9.77662 14.4159 8.00027C14.4159 6.22391 13.7907 4.71047 12.5403 3.45994C11.29 2.2094 9.77662 1.58413 8.00027 1.58413C6.22391 1.58413 4.71047 2.20931 3.45994 3.45967C2.2094 4.71003 1.58413 6.22338 1.58413 7.99973C1.58413 9.77609 2.20931 11.2895 3.45967 12.5401C4.71003 13.7906 6.22338 14.4159 7.99973 14.4159Z"
                    fill={fill || '#289B67'}
                />
            </g>
        </svg>
    ),
} as const;
